import { Reducer } from '@reduxjs/toolkit';

const resetFiltersReducer: Reducer = (
  state, { payload },
) => (
  {
    ...state,
    resetFilters: payload,
  }
);

export default resetFiltersReducer;
